
<template>
  <section>
    <span class="c-about__basquait"></span>
    <div
      class="o-section__max-w o-section--pt o-section--about"
      v-bind:class="{'o-section--about--first':firstLoad}"
    >
      <div class="c-about__image-container c-about__image-container--left">
        <img class="c-about__image c-about__image--left c-about__image--left--dup" v-bind:src="nz" />
        <img
          class="c-about__image c-about__image--left c-about__image--left--1"
          v-bind:src="making"
        />
        <span class="js-block js-block--image"></span>
      </div>
      <div class="c-about__image-container c-about__image-container--right">
        <img
          class="c-about__image c-about__image--right c-about__image--right--dup"
          v-bind:src="legend"
        />
        <img
          class="c-about__image c-about__image--right c-about__image--right--1"
          v-bind:src="printing"
        />
        <span class="js-block js-block--image"></span>
      </div>
      <div class="c-about__text">
        <h1 class="c-about__title js-anim">
          <span class="c-about__title--cap">A</span>RTFUL
          <span class="c-about__title--cap">D</span>ODGERS
        </h1>
        <h4 class="c-about__intro js-anim">FOUNDED IN 2018</h4>
        <p class="c-about__sub-intro js-anim">
          <span class="js-block js-block--text"></span>
          <span class="js-left-g">THE UNINVITED GUEST WHO STAYS 'TILL THE END</span>
          <span class="js-left-og">
            TIRED OF SKULLS, BONES AND
            <span
              @mouseenter="hoverBasquiat()"
              @mouseleave="leaveBasquiat()"
              class="c-about__text--highlighted basquiat-hover"
            >BASQUIAT</span> COPY CATS.
          </span>
        </p>
        <p class="c-about__aside js-anim">
          <span class="js-block js-block--text"></span>
          <span
            class="js-right-g"
          >A RENAISSANCE OF CLASSICAL STYLES CREATED WITH MODERN PRECISION AND ACCURACY.</span>
          <span class="js-right-og">
            OUR WORKS ARE DESIGNED AND CRAFTED IN
            <span
              class="c-about__text--highlighted js-nz"
              @mouseenter="hoverNZ()"
              @mouseleave="leaveNZ()"
            >NEW ZEALAND</span> USING A COMBINATION OF 3D PRINTING AND TRADITIONAL TECHNIQUES.
          </span>
        </p>
        <h3
          class="c-about__send-off js-anim"
          @mouseenter="hoverBottom()"
          @mouseleave="leaveBottom()"
        >
          MADE TO LAST FOR GENERATIONS
          <br />
          <span style="font-size:120px; line-height:0px;">.</span>
        </h3>
      </div>
    </div>
  </section>
</template>

<script>
const images = {
  legend: {
    png: "/assets/img/about-absolute-legend-desktop.png",
    webp: "/assets/img/about-absolute-legend-desktop.webp",
  },
  nz: {
    png: "/assets/img/about-nz-desktop.png",
    webp: "/assets/img/about-nz-desktop.webp",
  },
  making: {
    png: "/assets/img/about-making-desktop.png",
    webp: "/assets/img/about-making-desktop.webp",
  },
  printing: {
    png: "/assets/img/about-printing-desktop.png",
    webp: "/assets/img/about-printing-desktop.webp",
  },
};

export default {
  metaInfo: {
    title: "About",
    meta: [
      {
        name: "description",
        content: "The Artful Dodgers Ltd About. Treat yourself! ",
      },
      { property: "og:title", content: "About | Artful Dodgers Ltd" },
      { property: "og:site_name", content: "Artful Dodgers" },
      {
        property: "og:description",
        content: "The Artful Dodgers Ltd Shop. Treat yourself!",
      },
      { property: "og:type", content: "about" },
      { property: "og:url", content: "https://artfuldodgers.co.nz/about" },
      {
        property: "og:image",
        content: "https://artfuldodgers.co.nz/assets/img/ad-trixy-ring.png",
      },
    ],
  },
  data: function () {
    return {
      firstLoad: false,
      legend: "/assets/img/about-absolute-legend-desktop.webp",
      nz: "/assets/img/about-nz-desktop.webp",
      making: "/assets/img/about-making-desktop.webp",
      printing: "/assets/img/about-printing-desktop.webp",
    };
  },
  methods: {
    hoverNZ: function () {
      $(".js-block--image").css("transform-origin", "left");
      TweenMax.staggerTo(
        $(".js-block--image"),
        0.2,
        { scaleX: 1, ease: Power1.easeOut },
        0.1
      );
      setTimeout(function () {
        $(".c-about__image--right--1").css("opacity", 0);
        $(".c-about__image--left--1").css("opacity", 0);
        $(".c-about__image--right--dup").css("opacity", 1);
        $(".c-about__image--left--dup").css("opacity", 1);
        $(".js-block--image").css("transform-origin", "right");
        setTimeout(function () {
          TweenMax.staggerTo(
            $(".js-block--image"),
            0.2,
            { scaleX: 0, ease: Power1.easeIn },
            0.1
          );
        }, 20);
      }, 310);
    },
    leaveNZ: function () {
      $(".js-block--image").css("transform-origin", "left");
      TweenMax.staggerTo(
        $(".js-block--image"),
        0.2,
        { scaleX: 1, ease: Power1.easeOut },
        0.1
      );
      setTimeout(function () {
        $(".c-about__image--right--1").css("opacity", 1);
        $(".c-about__image--left--1").css("opacity", 1);
        $(".c-about__image--right--dup").css("opacity", 0);
        $(".c-about__image--left--dup").css("opacity", 0);
        $(".js-block--image").css("transform-origin", "right");
        setTimeout(function () {
          TweenMax.staggerTo(
            $(".js-block--image"),
            0.2,
            { scaleX: 0, ease: Power1.easeIn },
            0.1
          );
        }, 20);
      }, 310);
    },
    hoverBasquiat: function () {
      TweenMax.to($(".c-about__basquait"), 0.2, { opacity: 0.05 });
    },
    leaveBasquiat: function () {
      TweenMax.to($(".c-about__basquait"), 0.2, { opacity: 0 });
    },
    hoverBottom: function () {
      $(".js-block--text").css("transform-origin", "left");
      TweenMax.staggerTo(
        $(".js-block--text"),
        0.2,
        { scaleX: 1, ease: Power1.easeOut },
        0.1
      );
      setTimeout(function () {
        $(".js-right-g").css("opacity", 1);
        $(".js-left-g").css("opacity", 1);
        $(".js-right-og").css("opacity", 0);
        $(".js-left-og").css("opacity", 0);
        $(".js-block--text").css("transform-origin", "right");
        setTimeout(function () {
          TweenMax.staggerTo(
            $(".js-block--text"),
            0.2,
            { scaleX: 0, ease: Power1.easeIn },
            0.1
          );
        }, 20);
      }, 310);
    },
    leaveBottom: function () {
      $(".js-block--text").css("transform-origin", "left");
      TweenMax.staggerTo(
        $(".js-block--text"),
        0.2,
        { scaleX: 1, ease: Power1.easeOut },
        0.1
      );
      setTimeout(function () {
        $(".js-right-g").css("opacity", 0);
        $(".js-left-g").css("opacity", 0);
        $(".js-right-og").css("opacity", 1);
        $(".js-left-og").css("opacity", 1);
        $(".js-block--text").css("transform-origin", "right");
        setTimeout(function () {
          TweenMax.staggerTo(
            $(".js-block--text"),
            0.2,
            { scaleX: 0, ease: Power1.easeIn },
            0.1
          );
        }, 20);
      }, 310);
    },
    loadAbout: function () {
      var self = this;
      setTimeout(function () {
        TweenMax.to($(".c-loading__line-text"), 0.2, {
          x: 200,
          opacity: 0,
          ease: Power2.easeIn,
        });
      }, 100);
      $(".c-loading__line").css("transform-origin", "right");
      TweenMax.to($(".c-loading__line"), 0.5, {
        scaleX: 0,
        ease: Power1.easeOut,
      });

      var rightWidth1 = "calc(30% - 200px)";
      var rightWidth2 = "calc(50% - 200px)";
      var leftWidth2 = "calc(50% - 130px)";
      var leftWidth1 = "calc(30% - 130px)";
      var rightHeight1 = "400px";
      var leftHeight1 = "260px";

      var thousand = window.matchMedia("(min-width: 1000px)");
      var thirteen = window.matchMedia("(min-width: 1300px)");
      var fourteen = window.matchMedia("(min-width: 1400px)");
      var fuckingLarge = window.matchMedia("(min-width: 2400px)");
      if (fourteen.matches) {
        var rightWidth1 = "calc(30% - 445px)";
        var rightWidth2 = "calc(50% - 445px)";
      }
      if (thirteen.matches) {
        var leftWidth2 = "calc(50% - 330px)";
        var leftWidth1 = "calc(30% - 330px)";
      }
      if (thousand.matches) {
        var rightHeight1 = "600px";
        var leftHeight1 = "400px";
        var rightWidth1 = "calc(30% - 300px)";
        var rightWidth2 = "calc(50% - 300px)";
        var leftWidth2 = "calc(50% - 250px)";
        var leftWidth1 = "calc(30% - 250px)";
      }
      if (fuckingLarge.matches) {
        var rightHeight1 = "900px";
        var leftHeight1 = "600px";
        var rightWidth1 = "calc(30% - 450px)";
        var rightWidth2 = "calc(50% - 450px)";
        var leftWidth2 = "calc(50% - 323px)";
        var leftWidth1 = "calc(30% - 323px)";
      }

      setTimeout(function () {
        setTimeout(function () {
          TweenMax.fromTo(
            $(".c-about__image-container--right"),
            1,
            { width: rightWidth1, height: 0 },
            { width: rightWidth2, height: rightHeight1, ease: Power2.easeOut }
          );
          setTimeout(function () {
            TweenMax.fromTo(
              $(".c-about__image--right"),
              0.8,
              { scale: 0.8 },
              { scale: 1.1, ease: Power2.easeOut }
            );
          }, 50);
        }, 100);
        TweenMax.fromTo(
          $(".c-about__image-container--left"),
          1,
          { width: leftWidth1, height: 0 },
          { width: leftWidth2, height: leftHeight1, ease: Power2.easeOut }
        );
        setTimeout(function () {
          TweenMax.fromTo(
            $(".c-about__image--left"),
            0.8,
            { scale: 0.8 },
            { scale: 1.1, ease: Power2.easeOut }
          );
        }, 50);

        setTimeout(function () {
          TweenMax.fromTo(
            $(".c-about__title"),
            1.2,
            { x: 190, scaleX: 1.2, opacity: 0 },
            { x: 0, scaleX: 1, opacity: 1, ease: Power2.easeOut }
          );

          //LOADING LINE
          $(".c-loading__line").css("background", "#000");
          $(".c-loading__line-text").css("color", "#000");
          self.$parent.loadingLine = false;
        }, 200);
        setTimeout(function () {
          TweenMax.staggerFromTo(
            $(".c-about__intro"),
            1.4,
            { opacity: 0 },
            { opacity: 1, ease: Power2.easeOut },
            0.25
          );
          setTimeout(function () {
            TweenMax.fromTo(
              $(".c-about__sub-intro"),
              1.4,
              { opacity: 0 },
              { opacity: 1, ease: Power1.easeOut }
            );
          }, 250);

          setTimeout(function () {
            TweenMax.fromTo(
              $(".c-about__aside"),
              1.4,
              { opacity: 0 },
              { opacity: 1, ease: Power1.easeOut }
            );
          }, 250);
          setTimeout(function () {
            TweenMax.fromTo(
              $(".c-about__send-off"),
              1.4,
              { x: 120, opacity: 0 },
              { x: 0, opacity: 1, ease: Power4.easeOut }
            );
          }, 150);
        }, 250);
      }, 300);
    },
  },
  watch: {},
  created: function () {
    var self = this;
    if (!self.$parent.loadAbout) {
      self.firstLoad = true;
    }
    var waitToLoad = setInterval(function () {
      if (self.$parent.initLoad) {
        clearInterval(waitToLoad);
        self.loadAbout();
      }
    }, 100); // check every 100ms
  },
  mounted: function () {
    var self = this;
    Modernizr.on("webp", function (result) {
      if (!result) {
        setTimeout(function () {
          self.nz = images.nz.png;
          self.legend = images.legend.png;
          self.making = images.making.png;
          self.printing = images.printing.png;
        }, 400);
      }
    });
  },
};
</script>

<style scoped  lang="scss">
.js-right-g,
.js-left-g {
  opacity: 0;
  top: 0;
  left: 0;
  position: absolute;
  pointer-events: none;
  font-weight: 300;
}
.js-block {
  z-index: 1000;
  position: absolute;
  content: "";
  display: block;
  left: 0;
  right: 0;
  transform-origin: left;
  background: white;
  height: 100%;
  width: 100%;
  top: 0;
  transform: scaleX(0);
}
.c-about__basquait {
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: url("/assets/img/bascursor.svg");
  background-size: 100px;
  mix-blend-mode: lighten;
  z-index: 100;
  opacity: 0;
  pointer-events: none;
}
.basquiat-hover:hover {
  cursor: url("/assets/img/bascursor.png"), default;
}
.js-anim {
  opacity: 0;
}
.c-about__image {
  background-position-x: -140px;
  position: absolute;
  height: 440px;
  left: 0;
  object-fit: cover;
  background-size: cover;
  background-repeat: no-repeat;
  transform-origin: bottom left;
  @media all and (max-width: 760px) {
    display: none;
  }

  bottom: -150px;
  @media all and (min-width: 1050px) {
    bottom: 0;
  }

  @media all and (min-width: 2400px) {
    width: 100%;
  }
  @media all and (min-width: 2400px) {
    height: auto;
  }
}
.c-about__image--right {
  height: 600px;
  @media all and (min-width: 2400px) {
    height: auto;
  }
}
.c-about__image--right--dup {
  height: 600px;
  opacity: 0;
  @media all and (max-width: 1280px) {
    left: -140px;
  }
  @media all and (min-width: 2400px) {
    height: auto;
  }
}
.c-about__image--left--dup {
  height: 435px;
  opacity: 0;

  @media all and (max-width: 1280px) {
    right: -190px;
  }
  @media all and (min-width: 2400px) {
    height: auto;
  }
}
.c-about__image--right--1 {
  @media all and (max-width: 1280px) {
    left: -90px;
  }
}
.c-about__image--left--1 {
  @media all and (max-width: 1280px) {
    left: -90px;
  }
}
.c-about__image-container {
  transform-origin: bottom left;
  /* height:400px; */
  overflow: hidden;
  position: absolute;
  display: block;
  z-index: 1;
  bottom: 0;
  @media all and (max-width: 760px) {
    display: none;
  }
}
.c-about__image-container--left {
  @supports (-ms-ime-align: auto) {
    width: calc(50% - 130px) !important;
    @media all and (min-width: 1000px) {
      width: calc(50% - 250px) !important;
    }
    @media all and (min-width: 1300px) {
      width: calc(50% - 330px) !important;
    }
    @media all and (min-width: 2400px) {
      width: calc(50% - 323px) !important;
    }
  }
}
.c-about__image-container--right {
  left: calc(50% + 230px);
  @media all and (min-width: 1050px) {
    left: calc(50% + 300px);
  }
  @media all and (min-width: 1400px) {
    left: calc(50% + 445px);
  }
  @media all and (min-width: 2600px) {
    height: 800px;
  }

  @supports (-ms-ime-align: auto) {
    width: calc(50% - 130px) !important;
    @media all and (min-width: 1000px) {
      width: calc(50% - 250px) !important;
    }
    @media all and (min-width: 1300px) {
      width: calc(50% - 330px) !important;
    }
    @media all and (min-width: 1400px) {
      width: calc(50% - 445px) !important;
    }
    @media all and (min-width: 2400px) {
      width: calc(50% - 323px) !important;
    }
  }
}
.o-section--about {
  max-width: none !important;
  max-height: none !important;
  background: #0c0c0c;
  color: white;
  position: relative;
  height: auto;

  padding-top: 20px;
  padding-bottom: 50px;
  @media all and (min-width: 500px) {
    padding-top: 30px;
  }
  @media all and (min-width: 580px) {
    padding-top: 40px;
    padding-top: 0px;
  }
  @media all and (min-width: 740px) {
    padding-bottom: 30px;
  }
  @media all and (min-width: 1050px) {
    height: calc(100vh - 257px);
    padding-top: 80px;
  }
  @media all and (min-width: 2400px) {
    height: calc(100vh - 400px);
    padding-left: 0;
    padding-right: 0;
  }
  @media all and (min-width: 2600px) {
    padding-left: 0;
    padding-right: 0;
  }
}
.o-section--about--first {
  background: #000;
}
.c-about__intro {
  font-weight: 100;
  margin-left: 80px;

  font-size: 12px;
  margin-left: 20px;
  @media all and (min-width: 270px) {
    font-size: 16px;
    margin-left: 40px;
  }
  @media all and (min-width: 600px) {
    margin-left: 80px;
    font-size: 22px;
  }
  @media all and (min-width: 1050px) {
    font-size: 24px;
    margin-left: 220px;
  }
  @media all and (min-width: 2400px) {
    font-size: 42px;
  }
  @media all and (min-width: 2600px) {
    font-size: 42px;
  }
}
.c-about__aside {
  font-weight: 100;
  position: relative;
  font-weight: 100;
  display: inline-block;
  letter-spacing: 0.2px;
  margin-right: 5px;
  text-align: right;

  font-size: 12px;
  line-height: 14px;
  width: 100%;
  margin-top: 15px;
  @media all and (min-width: 270px) {
    line-height: 22px;
    font-size: 16px;
  }
  @media all and (min-width: 760px) {
    margin-top: 25px;
    width: 350px;
    float: right;
  }
  @media all and (min-width: 900px) {
    width: 390px;
    font-size: 18px;
  }
  @media all and (min-width: 1000px) {
    margin-right: 55px;
  }
  @media all and (min-width: 1050px) {
    margin-right: 105px;
    width: 400px;
    font-size: 18px;
  }
  @media all and (min-width: 1250px) {
    line-height: 26px;
    width: 480px;
    font-size: 20px;
  }
  @media all and (min-width: 1400px) {
    font-size: 24px;
    line-height: 30px;
    width: 540px;
  }
  @media all and (min-width: 2400px) {
    font-size: 36px;
    line-height: 42px;
    width: 760px;
    margin-top: 70px;
  }
  @media all and (min-width: 2600px) {
    font-size: 36px;
    line-height: 42px;
    width: 760px;
    margin-top: 70px;
  }
}
.c-about__sub-intro {
  position: relative;
  font-weight: 100;
  background-blend-mode: difference;
  mix-blend-mode: difference;
  display: inline-block;
  font-size: 30px;
  margin-top: 25px;
  @media all and (min-width: 270px) {
    font-size: 34px;
  }
  width: 100%;
  @media all and (min-width: 760px) {
    width: 350px;
  }
  @media all and (min-width: 900px) {
    margin-top: 45px;
    width: 390px;
    font-size: 36px;
  }
  @media all and (min-width: 1050px) {
    width: 435px;
    font-size: 40px;
  }
  @media all and (min-width: 1250px) {
    width: 525px;
    font-size: 50px;
  }
  @media all and (min-width: 1400px) {
    width: 645px;
    font-size: 60px;
  }
  @media all and (min-width: 2400px) {
    width: 945px;
    margin-top: 70px;
    font-size: 90px;
  }
  @media all and (min-width: 2600px) {
    width: 945px;
    margin-top: 70px;
    font-size: 90px;
  }
}
.c-about__text--highlighted {
  font-weight: 400;
}
.c-about__text {
  margin: 0 auto;
  z-index: 10;
  text-shadow: 2px 1px 3px black;
  position: relative;
  margin: 0 10px;

  @media all and (min-width: 740px) {
    margin: 0 auto;
    max-width: 720px;
  }
  @media all and (min-width: 900px) {
    max-width: 840px;
  }
  @media all and (min-width: 1050px) {
    max-width: 1000px;
  }
  @media all and (min-width: 1250px) {
    max-width: 1180px;
  }
  @media all and (min-width: 1400px) {
    max-width: 1300px;
  }
  @media all and (min-width: 2400px) {
    max-width: 1880px;
  }
}
.c-about__title {
  font-family: GTSpectra;
  white-space: nowrap;
  transform-origin: left;
  font-display: swap;

  font-size: 24px;
  @media all and (min-width: 280px) {
    font-size: 30px;
  }
  @media all and (min-width: 320px) {
    font-size: 32px;
  }
  @media all and (min-width: 490px) {
    font-size: 42px;
  }
  @media all and (min-width: 590px) {
    font-size: 52px;
  }
  @media all and (min-width: 720px) {
    font-size: 62px;
  }
  @media all and (min-width: 900px) {
    font-size: 70px;
  }
  @media all and (min-width: 970px) {
    font-size: 80px;
  }
  @media all and (min-width: 1050px) {
    font-size: 90px;
  }
  @media all and (min-width: 1250px) {
    font-size: 100px;
  }
  @media all and (min-width: 1400px) {
    font-size: 115px;
  }
  @media all and (min-width: 1500px) {
    font-size: 125px;
  }
  @media all and (min-width: 2400px) {
    font-size: 155px;
  }
  @media all and (min-width: 2600px) {
    font-size: 165px;
  }
}
.c-about__title--cap {
  font-family: GTSpectra;

  font-size: 28px;
  @media all and (min-width: 270px) {
    font-size: 32px;
  }
  @media all and (min-width: 320px) {
    font-size: 48px;
  }
  @media all and (min-width: 490px) {
    font-size: 58px;
  }
  @media all and (min-width: 590px) {
    font-size: 68px;
  }
  @media all and (min-width: 720px) {
    font-size: 78px;
  }
  @media all and (min-width: 900px) {
    font-size: 90px;
  }
  @media all and (min-width: 970px) {
    font-size: 105px;
  }
  @media all and (min-width: 1050px) {
    font-size: 115px;
  }
  @media all and (min-width: 1250px) {
    font-size: 135px;
  }
  @media all and (min-width: 1400px) {
    font-size: 165px;
  }
  @media all and (min-width: 2400px) {
    font-size: 185px;
  }
}
.c-about__send-off:hover {
  cursor: url("/assets/img/SHAKA.png"), default;
}
.c-about__send-off {
  font-weight: 400;
  word-break: break-word;

  margin-top: 15px;
  font-size: 30px;
  @media all and (min-width: 270px) {
    font-size: 42px;
  }
  @media all and (min-width: 760px) {
    margin-top: 0;
    margin-left: 240px;
  }
  @media all and (min-width: 900px) {
    margin-left: 440px;
  }
  @media all and (min-width: 980px) {
    font-size: 50px;
    margin-left: 420px;
    margin-top: 10px;
  }
  @media all and (min-width: 1250px) {
    font-size: 72px;
    margin-top: 24px;
  }
  @media all and (min-width: 2400px) {
    font-size: 122px;
    margin-top: 60px;
  }
  @media all and (min-width: 2600px) {
    font-size: 122px;
    margin-top: 154px;
  }
}
strong,
.c-about__sub-intro span {
  &::-moz-selection {
    color: #000;
    background: rgba(255, 255, 255, 0.99);
    background-color: rgba(255, 255, 255, 0.99);
    opacity: 1;
  }
  &::selection {
    color: #000;
    background: rgba(255, 255, 255, 0.99);
    background-color: rgba(255, 255, 255, 0.99);
    opacity: 1;
  }
}
.js-nz:hover {
  cursor: url("/assets/img/newzealand.png"), default;
}
</style>


// WEBPACK FOOTER //
// About.vue?13993ba8